import {createAction} from "@reduxjs/toolkit";

export const userLogoutAction = createAction('userLogout');